module.exports = __webpack_public_path__ + "img/logo-startupcitiesmap.c348a24f.svg";